<template>
  <iframe
    v-if="accessToken && getUrl"
    :src="getUrl"
    referrerpolicy="no-referrer-when-downgrade"
    loading="lazy"
    allow="clipboard-write"
    class="iframe"
  />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DisputeContentAppointmentDetails',

  data() {
    return {
      accessToken: null,
    }
  },

  computed: {
    ...mapGetters(['appointment']),

    hCheckURL() {
      return process.env.VUE_APP_CHECKLIST_URL
    },

    getUrl() {
      if (!this.accessToken) return null
      return `${this.hCheckURL}/asset-report/view/${this.appointment.job_id}?accessToken=${this.accessToken}`
    },
  },

  methods: {
    waitForToken() {
      const checkToken = () => {
        const token = localStorage.getItem('access_token')

        if (token && token.split('.').length === 3) {
          this.accessToken = token
        } else {
          setTimeout(checkToken, 300)
        }
      }

      checkToken()
    },
  },


  mounted() {
    this.waitForToken()
  },
}
</script>

<style scoped>
.iframe {
  border: 0;
  width: 100%;
  min-height: calc(100vh - 150px);
}
</style>
